module.exports = __webpack_public_path__ + "img/spinner-02.d5510500.png";